import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../../shared';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { ModalModule } from 'ngx-bootstrap/modal';
import { EffectsModule } from '@ngrx/effects';
import { InternalSharedModule } from '../shared';
import { AdminEffects } from './admin-store/admin.effects';
import { services } from './shared/services';
import { adminRoutes } from './admin.routing';
import { AdminMainComponent } from './layout/main';
import { AdminImportRequestComponent } from './pages/admin-import-request';
import { AdminAddPortfolioComponent } from './pages/admin-add-portfolio';
import { AdminImportRequestListComponent } from './components/admin-import-request-list';
import { AdminImportRequestDetailsComponent } from './components/admin-import-request-details';
import { AdminLeftMenuComponent } from './components/left-menu';
import { AdminImportRequestsComponent } from './pages/admin-import-requests';
import { FilterImportRequestsPipe, ImportRequestStatusPipe } from './shared/pipes';
import { AdminPropertiesComponent } from './pages/admin-properties';
import { AdminPropertyListComponent } from './components/admin-property-list';
import { AdminPropertyComponent } from './pages/admin-property';
import { AdminPropertyDetailsComponent } from './components/admin-property-details';
import { AdminPropertyExportMapComponent } from './pages/admin-property-export-map';
import { AdminPropertyExportMapDetailsComponent } from './components/admin-property-export-map-details';
import { AdminExportMapImportComponent } from './components/admin-export-map-import';
import { AdminDataImportRequestImportComponent } from './components/admin-data-import-request-import';
import { AdminDataImportRequestExportDiffComponent } from './components/admin-data-import-request-export-diff';
import { AddConnectedAppModalComponent } from './components/add-connected-app-modal/add-connected-app-modal.component';
import { AddConnectedAppCredentialComponent } from './components/add-connected-app-credential/add-connected-app-credential.component';
import { AddVantacaCredentialComponent } from './components/integrations/Vantaca/add-credential/add-vantaca-credential.component';
import { AddCincCredentialComponent } from './components/integrations/Cinc/add-credential/add-cinc-credential.component';
import { AddAppFolioCredentialComponent } from './components/integrations/AppFolio/add-credential/add-appfolio-credential.component';
import { AdminPortfoliosComponent } from './pages/admin-portfolios';
import { AdminPortfolioComponent } from './pages/admin-portfolio';
import { PropertyModule } from '../property';
import { UserModule } from '../user';
import { AdminPortfolioPropertiesComponent } from './components/portfolios/admin-edit-portfolio-properties';
import { AdminPortfolioListComponent } from './components/portfolios/admin-portfolio-list';
import { AdminPortfolioEditUserComponent } from './pages/admin-portfolio-edit-user';
import { AdminUsersComponent } from './pages/admin-users/admin-users.component';
import { AdminUserListComponent } from './components/admin-user-list/admin-user-list.component';
import { AdminPortfolioEditPropertyComponent } from './pages/admin-portfolio-edit-property';
import { AdminConnectedAppsComponent } from './components/portfolios/admin-portfolio-edit-connected-apps/admin-portfolio-edit-connected-apps.component';
import { AdminUserComponent } from './pages/admin-user/admin-user.component';
import { AdminUserEditComponent } from './components/admin-user-edit/admin-user-edit.component';
import { AdminSettingsComponent } from './pages/admin-settings/admin-settings.component';
import { AdminReassignPropertyModalComponent } from './components/admin-reassign-property-modal/admin-reassign-property-modal.component';
import { AddEUnifyCredentialComponent } from './components/integrations/eUnify/add-credential/add-eunify-credential.component';
import { DxDataGridModule } from 'devextreme-angular/ui/data-grid';
import { DxButtonModule } from 'devextreme-angular/ui/button';
import { DxCheckBoxModule } from 'devextreme-angular/ui/check-box';
import { DxAutocompleteModule } from 'devextreme-angular/ui/autocomplete';
import { DxListModule } from 'devextreme-angular/ui/list';
import { DxSelectBoxModule } from 'devextreme-angular/ui/select-box';
import { DxFileUploaderModule } from 'devextreme-angular/ui/file-uploader';

const PROVIDERS = [
  ...services
];
@NgModule({
  imports: [
    CommonModule,
    EffectsModule.forFeature([AdminEffects]),
    FormsModule,
    InternalSharedModule,
    ModalModule,    
    ReactiveFormsModule,
    RouterModule.forChild(adminRoutes),
    SharedModule,
    DxDataGridModule,
    DxButtonModule,
    PropertyModule,
    UserModule,
    DxCheckBoxModule,
    DxAutocompleteModule,
    DxListModule,
    DxSelectBoxModule,
    DxFileUploaderModule
  ],
  providers: [
    PROVIDERS
  ],
  declarations: [
    /* Layouts */
    AdminMainComponent,

    /* Pages */
    AdminImportRequestComponent,
    AdminImportRequestsComponent,
    AdminPropertiesComponent,
    AdminPropertyComponent,
    AdminPropertyExportMapComponent,
    AdminAddPortfolioComponent,
    AdminPortfolioComponent,
    AdminPortfoliosComponent,
    AdminPortfolioEditUserComponent,
    AdminPortfolioEditPropertyComponent,

    /* Components */
    AdminDataImportRequestExportDiffComponent,
    AdminDataImportRequestImportComponent,
    AdminExportMapImportComponent,
    AdminImportRequestDetailsComponent,
    AdminImportRequestListComponent,
    AdminLeftMenuComponent,
    AdminPropertyDetailsComponent,
    AdminPropertyExportMapDetailsComponent,
    AdminPropertyListComponent,
    AddVantacaCredentialComponent,
    AddCincCredentialComponent,
    AddAppFolioCredentialComponent,
    AddEUnifyCredentialComponent,
    AdminPortfolioListComponent,
    AdminPortfolioPropertiesComponent,
    AdminConnectedAppsComponent,
    AdminSettingsComponent,
    AddConnectedAppModalComponent,
    AddConnectedAppCredentialComponent,
    AdminUsersComponent,
    AdminUserListComponent,
    AdminUserComponent,
    AdminUserEditComponent,
    AdminReassignPropertyModalComponent,

    /* Pipes */
    FilterImportRequestsPipe,
    ImportRequestStatusPipe,
  ],
  exports: [
    AdminMainComponent
  ]
})
export class AdminModule { }
